import { useEffect } from "react";
import { motion } from "motion/react";
import { LegalLinks } from "./LegalViews";

export function AboutScreen() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "About CraftOff: Minecraft Crafting Competition";
    return () => { document.title = previousTitle; };
  }, []);

  return (
    <motion.section className="about-screen" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <article className="about-card">
        <img className="about-logo" src="/brand/craftoff-oauth-logo.png" alt="CRAFTOFF logo" />
        <p className="about-eyebrow">MINECRAFT CRAFTING COMPETITION</p>
        <h1>CRAFTOFF</h1>
        <p className="about-intro">
          <strong>CraftOff is a free online Minecraft crafting competition.</strong> Players race against an
          opponent to complete item recipes in a 3 by 3 crafting grid. Win matches to earn XP, unlock ranked
          competition, and climb the public leaderboard.
        </p>

        <section className="about-details" aria-label="How CRAFTOFF works">
          <div>
            <h2>HEAD-TO-HEAD CRAFTING RACES</h2>
            <p>Each round shows a target item. Place the correct ingredients into the crafting grid and finish the Minecraft recipe before your opponent.</p>
          </div>
          <div>
            <h2>PRACTICE MINECRAFT RECIPES</h2>
            <p>Use the Learn section to study crafting recipes, search the item catalog, and build the speed needed for competitive matches.</p>
          </div>
        </section>

        <section className="about-account-data">
          <h2>QUICK MATCHES, RANKED PLAY, AND XP</h2>
          <p>Create an account, earn XP from Quick Play, and unlock ranked matchmaking. A CraftOff account saves your progress and connects your public username to the leaderboard.</p>
        </section>

        <section className="about-account-data">
          <h2>EMAIL AND PASSWORD ACCOUNTS</h2>
          <p>Create an account with your email and a strong password to save XP and unlock account-only features. Your email stays private; other players see only your chosen public username.</p>
        </section>

        <section className="about-account-data">
          <h2>INDEPENDENT FAN-MADE GAME</h2>
          <p>CraftOff is an independent fan-made browser game and is not affiliated with, endorsed by, or sponsored by Mojang Studios or Microsoft. Minecraft names, imagery, and related rights belong to their respective owners.</p>
        </section>

        <div className="about-actions">
          <a className="minecraft-button about-play-button" href="/">PLAY CRAFTOFF</a>
          <a className="about-support-link" href="mailto:support@craftoff.io">support@craftoff.io</a>
        </div>
        <footer><LegalLinks /></footer>
      </article>
    </motion.section>
  );
}
